export const SMART_DOC_PROPERTY_NAME = 'EntityExtraction/SendContentRequestV21.0';
export const SMART_DOC_LOGGABLE_TEXT = 'Attach a file';
